<template>
  <div class="container-fluid mt-2">
    <h2>Service Anfragen</h2>
    <div role="toolbar" class="btn-toolbar justify-content-between">
      <div class="btn-group">
        <button @click="prevPage" class="btn btn-secondary"><font-awesome-icon icon="chevron-left"/></button>
        <button @click="nextPage" class="btn btn-secondary"><font-awesome-icon icon="chevron-right"/></button>
      </div>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">Status</span>
        </div>
        <select v-model="filteropen" @change="fetchData()" class="form-control" id="serstat">
          <option value="">Alle</option>
          <option value="0">Offen</option>
          <option value="1">Abgeschlossen</option>
        </select>
      </div>
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">Anfrage</span>
        </div>
        <select v-model="filterrid" @change="fetchData()" class="form-control" id="sertype">
          <option value="">Alle</option>
          <option v-for="rt in reqtypes" :key="rt" :value="rt">{{ rt }}</option>
        </select>
      </div>
      <button @click="openTemplates" class="btn btn-primary">Vorlagen</button>
    </div>
    <b-table @row-clicked="openRequest" striped hover :items="rows" :fields="fields" class="mt-3">
      <template v-slot:cell(finished)="data">
        <font-awesome-icon v-if="data.item.finished" icon="check"/> 
      </template>
    </b-table>
  </div>
</template>

<script>
import router from '@/router'
import services from '@/modules/services.js'

export default {
  name: 'ServiceRequestList',
  data() {
    return {
      rows: [],
      fields: [
        {label:'ID', key:'id'},
        {label:'Type', key:'reqid'},
        {label:'Datum', key:'send'},
        {label:'Vertreter', key: v => { console.log(v); if (v.submitter) return v.submitter.handid; else return '-'; }},
        {label:'Kunde', key:'customer'},
        {label:'Process', key:'procid'},
        {label:'Abgeschlossen', key:'finished'},
      ],
      reqtypes: [],
      filteropen: '',
      filterrid: '',
    }
  },
  created: function() {
    this.updateTypes();
    this.fetchData();
  },
  methods: {
    openTemplates() {
      router.push({name: 'ServiceTemplateList'});
    },
    openRequest(row) {
      router.push({name: 'ServiceRequestView',params: {id: row.id }});
    },
    updateTypes() {
      var self = this;
      services.listtempnames(this,function(data) {
        self.reqtypes = data;
      })
    },
    fetchData() {
      var self = this;
      services.viewparams.open = this.filteropen;
      services.viewparams.type = this.filterrid;
      services.listrequests(this,function(data) {
        self.rows = data;
      })
    },
    nextPage() {
        if (this.rows.length > 0) {
            services.viewparams.start += services.viewparams.count;
            this.fetchData();
        }
    },
    prevPage() {
        if (services.viewparams.start > 0) {
            services.viewparams.start -= services.viewparams.count;
            this.fetchData();
        }
    }
  }
}
</script>
